import { render, staticRenderFns } from "./DecisionMakersPanel.vue?vue&type=template&id=324eb47f&scoped=true&"
import script from "./DecisionMakersPanel.vue?vue&type=script&lang=ts&"
export * from "./DecisionMakersPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionMakersPanel.vue?vue&type=style&index=0&id=324eb47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324eb47f",
  null
  
)

export default component.exports